/**
 * בונה אובייקט `pricingAuditMeta` רק משדות שמוגדרים (ללא מילוי placeholder שקט).
 * @param {Record<string, unknown>} fields
 * @returns {Record<string, unknown>|undefined}
 */
export function compactPricingAuditMeta(fields) {
  if (!fields || typeof fields !== "object") return undefined;
  /** @type {Record<string, unknown>} */
  const out = {};
  for (const [k, v] of Object.entries(fields)) {
    if (v === undefined || v === null) continue;
    if (typeof v === "string" && v.trim() === "") continue;
    out[k] = v;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
